import { JsonField } from "../../../apis/reportsApi";

type QSCustomProps = {
  [key: string]: string;
};

export const convertStringToBooleanIfNecessary = (
  value: string,
): string | boolean => {
  if (value === "true" || value === "false") {
    return JSON.parse(value);
  }

  return value;
};

export const getQuickSightCustomProps = (
  customProps: JsonField[],
): QSCustomProps => {
  return customProps.reduce((prev, curr) => {
    return {
      ...prev,
      [curr.key]: convertStringToBooleanIfNecessary(curr.value),
    };
  }, {});
};
